import type { StaffMember } from '@manaro/contracts'
import type { BadgeTone } from '@/shared/ui/badge.tsx'

export interface StaffStatusView {
  label: string
  tone: BadgeTone
}

/** An invite past its deadline still says «invited» on the server; the list should call it what it is. */
export function staffStatusView(member: Pick<StaffMember, 'status' | 'inviteExpiresAt'>, now = Date.now()): StaffStatusView {
  if (member.status === 'active') return { label: 'Активен', tone: 'brand' }
  if (member.status === 'disabled') return { label: 'Отключён', tone: 'neutral' }
  const expired = !member.inviteExpiresAt || new Date(member.inviteExpiresAt).getTime() <= now
  return expired ? { label: 'Ссылка истекла', tone: 'warn' } : { label: 'Ждёт входа', tone: 'info' }
}

/** Ready to paste into Telegram: who it is for, what to do, how long the link lives. */
export function inviteMessage(name: string, inviteUrl: string): string {
  const firstName = name.trim().split(/\s+/)[0] ?? name
  return [
    `${firstName}, привет! Это доступ в бэк-офис Manaro для поддержки.`,
    `Откройте ссылку и задайте пароль: ${inviteUrl}`,
    'Ссылка действует 72 часа и работает один раз.',
  ].join('\n')
}
